
import vClickOutside from 'v-click-outside';
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import staticId from '~/mixins/static-id';

export default {
    name: 'MyModal',
    mixins: [staticId],
    emits: ['closeModal'],
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        ecom: {
            type: Boolean,
            default: false
        },
        isMap: {
            type: Boolean,
            default: false
        },
        isConfirmNewPassword: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            isFarmacie: 'global/getIsFarmacie'
        }),
        generateId() {
            return this.idStatic;
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        closeModal: debounce(function (e, isConfirmNewPassword = false) {
            const currentModalContent = e.target.closest(`.my-modal__content`);

            if (e.target.closest(`.my-modal__content--map`)) {
                this.$store.commit('contacts/setIsShowMapModal', false);
                return;
            }
            if (currentModalContent?.className && this.$refs.modalContent?.className) {
                if (
                    !currentModalContent?.className.includes(`${this.generateId}`) ||
                    !this.$refs.modalContent?.className.includes(`${this.generateId}`)
                ) {
                    return;
                }
            }

            if (isConfirmNewPassword) {
                return;
            }
            this.$emit('closeModal', false);
        }, 10),
        injectDynamicStyles() {
            const selector = `.popup-open${this.idStatic}`;

            const css = `
              ${selector} {
                overflow: hidden;
                height: 100%;
                width: 100%;
                `;

            const styleTag = document.createElement('style');
            styleTag.setAttribute('data-modal-id', this.idStatic);
            styleTag.innerHTML = css;
            document.head.appendChild(styleTag);
        }
    },
    watch: {
        isOpen(newVal) {
            if (newVal) {
                document.body.classList.add(`popup-open${this.idStatic}`);
            } else {
                document.body.classList.remove(`popup-open${this.idStatic}`);
            }

            this.email = '';
        }
    },
    mounted() {
        this.injectDynamicStyles();
    },
    beforeDestroy() {
        const styleTag = document.querySelector(`style[data-modal-id="${this.idStatic}"]`);
        if (styleTag) styleTag.remove();
    }
};
